require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-rudersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-rudersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-rudersdorf!./.cache/json/betreuungseinrichtungen-jennersdorf-rudersdorf.json
// module id = 919
// module chunks = 231608221292675